import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    platform = 'PC',
    mobile = '',
    codeId = '',
    verifyCode = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.verifyCodeLogin, {
        platform,
        mobile,
        codeId,
        verifyCode,
    }, options);
    if (error) return { error, status };
    return content || {};
};

